<template>
    <li v-for="lang in languages" :key="lang.id" @click="switchLocale(lang.id)">
        <b v-if="lang.active">
            <a>{{lang.text}}</a>
        </b>
        <a v-else>{{lang.text}}</a>
    </li>
</template>

<script>
    export default {
        name: 'locale-changer',
        data () {
            return {
                langs: ['en_gb', 'de'],
                languages: {
                    "de": {
                        "id": "de",
                        "text": "Deutsch",
                        "active": false,
                    },
                    "en_gb": {
                        "id": "en_gb",
                        "text": "English",
                        "active": false,
                    },
                }
            }
        },
        methods: {
            switchLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    this.$i18n.locale = locale;
                    this.setCookie('library_lang', locale, 365);
                    this.$router.go();
                    this.languages.en_gb.active = true;
                    this.languages.de.active = false;
                }
            },
            setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=loxone.com;path=/";
            }
        },
        created() {
            if(this.$i18n.locale == "de") {
                this.languages.de.active = true;
            }else{
                this.languages.en_gb.active = true;
            }
        },
    }
</script>

<style lang="scss" scoped>
    li{
        a{
                color: #000000;
                text-decoration: none !important;
                padding: 0 15px;
                line-height: 40px;
                display: inline-block;
                width: 100%;
                box-sizing: border-box;
                cursor: poiner;
        }
    }
</style>>